import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import { Grid, FormLabel, FormControlLabel, TextField, Radio, Checkbox, Select, MenuItem } from '@material-ui/core'
import clsx from 'clsx'

class GiveFreeGame extends React.Component {
	constructor(props) {
		super(props)
		this.t = (key, options) => {
			return utils.t(key, 'GiveFreeGame', options)
		}

		this.state = {
			error: {
				activityConditionsOrders: false,
				activityConditionsBets: false,
				accumulationReach: false,
				accountLimitCount: false,
				allPlatformLimitCount: false,
				bonunsTotal: false,
				bonunsMin: false,
			},
			errorMsg: {
				activityConditionsOrders: '',
				activityConditionsBets: '',
				accumulationReach: '',
				accountLimitCount: '',
				allPlatformLimitCount: '',
				bonunsTotal: '',
				bonunsMin: '',
      },
			activityConditions: 'orders', // orders | bets
			accumulationOrders: 0,
			accumulationBets: 0,
			accumulationReach: 0,
			accountLimit: false,
			accountLimitCount: 0,
			allPlatformLimit: false,
			allPlatformLimitCount: 0,
			resetLimitCycle: '0',
			bonunsTotal: 0,
			bonunsMin: 0,
			resetbonunsCycle: '0',
			cycleList: [
				{
						value: '0',
						label: 'notReset'
				},{
						value: '1',
						label: 'everyDay'
				},{
						value: '2',
						label: 'Monday'
				},{
						value: '3',
						label: 'Tuesday'
				},{
						value: '4',
						label: 'Wednesday'
				},{
						value: '5',
						label: 'Thursday'
				},{
						value: '6',
						label: 'Friday'
				},{
						value: '7',
						label: 'Saturday'
				},{
						value: '8',
						label: 'Sunday'
				},{
						value: '9',
						label: 'everyMonth'
				},
			]
		}
	}
	errorVaild = {
		'activityConditionsOrders': {
			message: {
				require: utils.t('isRequired', 'EventDialog'),
				limit: utils.t('contentLimit', 'EventDialog')
			},
			vaild: (value) => {
				const bool = (!value || value.length > 16 || Number(value) < 1) || false
				const { require, limit } = this.errorVaild.activityConditionsOrders.message
				const errorMsg = (!value || Number(value) < 1) ? require : value.length > 16 ? limit : ''
				this.handleErrorState('activityConditionsOrders',  bool, errorMsg)
				return !bool
			}
		},
		'activityConditionsBets': {
			message: {
				require: utils.t('isRequired', 'EventDialog'),
				limit: utils.t('contentLimit', 'EventDialog')
			},
			vaild: (value) => {
				const bool = (!value || value.length > 16 || Number(value) < 1) || false
				const { require, limit } = this.errorVaild.activityConditionsBets.message
				const errorMsg = (!value || Number(value) < 1) ? require : value.length > 16 ? limit : ''
				this.handleErrorState('activityConditionsBets',  bool, errorMsg)
				return !bool
			}
		},
		'accumulationReach': {
			message: {
				require: utils.t('isRequired', 'EventDialog'),
				limit: utils.t('contentLimit', 'EventDialog')
			},
			vaild: (value) => {
				const bool = (!value || value.length > 16 || Number(value) < 1) || false
				const { require, limit } = this.errorVaild.accumulationReach.message
				const errorMsg = (!value || Number(value) < 1) ? require : value.length > 16 ? limit : ''
				this.handleErrorState('accumulationReach',  bool, errorMsg)
				return !bool
			}
		},
		'accountLimitCount': {
			message: {
				require: utils.t('isRequired', 'EventDialog'),
				limit: utils.t('contentLimit', 'EventDialog'),
				maxLimit: utils.t('moreThanCurrent', 'EventDialog')
			},
			vaild: (value) => {
				let bool = (!value || value.length > 16 || Number(value) < 1) || false
				const { require, limit, maxLimit } = this.errorVaild.accountLimitCount.message
				let errorMsg = (!value || Number(value) < 1) ? require : value.length > 16 ? limit : ''
				
				/** 編輯時判斷設定值是否大於/等於原值 */
				if (this.props.dialogType === 'edit' && Number(value) !== 0) {
					bool = Number(value) < Number(this.props.data.limit_prize_pf_account_count)
					errorMsg = bool ? maxLimit : ''
				}
				this.handleErrorState('accountLimitCount',  bool, errorMsg)
				return !bool
			}
		},
		'allPlatformLimitCount': {
			message: {
				require: utils.t('isRequired', 'EventDialog'),
				limit: utils.t('contentLimit', 'EventDialog'),
				maxLimit: utils.t('moreThanCurrent', 'EventDialog')
			},
			vaild: (value) => {
				let bool = (!value || value.length > 16 || Number(value) < 1) || false
				const { require, limit, maxLimit } = this.errorVaild.allPlatformLimitCount.message
				let errorMsg = (!value || Number(value) < 1) ? require : value.length > 16 ? limit : ''

				/** 編輯時判斷設定值是否大於/等於原值 */
				if (this.props.dialogType === 'edit' && Number(value) !== 0) {
					bool = Number(value) < Number(this.props.data.limit_prize_sub_pf_count)
					errorMsg = bool ? maxLimit : ''
				}
				this.handleErrorState('allPlatformLimitCount',  bool, errorMsg)
				return !bool
			}
		},
		'bonunsTotal': {
			message: {
				require: utils.t('isRequired', 'EventDialog'),
				limit: utils.t('contentLimit', 'EventDialog')
			},
			vaild: (value) => {
				const bool = (!value || value.length > 16 || Number(value) < 1) || false
				const { require, limit } = this.errorVaild.bonunsTotal.message
				const errorMsg = (!value || Number(value) < 1) ? require : value.length > 16 ? limit : ''
				this.handleErrorState('bonunsTotal',  bool, errorMsg)
				return !bool
			}
		},
		'bonunsMin': {
			message: {
				require: utils.t('isRequired', 'EventDialog'),
				limit: utils.t('contentLimit', 'EventDialog')
			},
			vaild: (value) => {
				const bool = (!value || value.length > 16 || Number(value) < 1) || false
				const { require, limit } = this.errorVaild.bonunsMin.message
				const errorMsg = (!value || Number(value) < 1) ? require : value.length > 16 ? limit : ''
				this.handleErrorState('bonunsMin',  bool, errorMsg)
				return !bool
			}
		},
	}
	handleErrorState = (key, bool, message) => {
		setTimeout(()=>{
			this.setState({
				error: {
					...this.state.error,
					[key]: bool
				},
				errorMsg: {
					...this.state.errorMsg,
					[key]: message
				}
			})
		}, 0)
	}

	handleValid() {
		const valid = []
		if (this.state.activityConditions === 'orders') {
			valid.push(this.errorVaild.activityConditionsOrders.vaild(this.state.accumulationOrders))
		} else {
			valid.push(this.errorVaild.activityConditionsBets.vaild(this.state.accumulationBets))
		}
		valid.push(this.errorVaild.accumulationReach.vaild(this.state.accumulationReach))
		this.state.accountLimit && valid.push(this.errorVaild.accountLimitCount.vaild(this.state.accountLimitCount))
		this.state.allPlatformLimit && valid.push(this.errorVaild.allPlatformLimitCount.vaild(this.state.allPlatformLimitCount))
		valid.push(this.errorVaild.bonunsTotal.vaild(this.state.bonunsTotal))
		valid.push(this.errorVaild.bonunsMin.vaild(this.state.bonunsMin))
		return valid.find(value => !value) === false ? false : true
	}

	handleEditInit() {
		const {
			record_count_threshold,
			bet_threshold,
			every_prize_count,
			limit_prize_pf_account_count,
			limit_prize_sub_pf_count,
			limit_reset_cycle_setting,
			total_money,
			ban_threshold_money,
			prize_money_reset_cycle_setting
		} = this.props.data

		const editData = {}

		if (Number(record_count_threshold) !== 0) {
			editData['activityConditions'] = 'orders'
			editData['accumulationOrders'] = record_count_threshold
		} else if (Number(bet_threshold) !== 0) {
			editData['activityConditions'] = 'bets'
			editData['accumulationBets'] = bet_threshold
		}

		editData['accumulationReach'] = every_prize_count

		if (Number(limit_prize_pf_account_count) > 0) {
			editData['accountLimit'] = true
			editData['accountLimitCount'] = limit_prize_pf_account_count
		}

		if (Number(limit_prize_sub_pf_count) > 0) {
			editData['allPlatformLimit'] = true
			editData['allPlatformLimitCount'] = limit_prize_sub_pf_count
		}
		editData['resetLimitCycle'] = limit_reset_cycle_setting
		editData['bonunsTotal'] = total_money
		editData['bonunsMin'] = ban_threshold_money
		editData['resetbonunsCycle'] = prize_money_reset_cycle_setting

		this.setState({
			...editData
		})
	}

	componentDidMount() {
		this.props.onRef(this)
		if (this.props.dialogType === 'edit') {
			this.handleEditInit()
		}
	}

	componentWillUnmount() {
		this.props.onRef(undefined)
	}
	render() {
		const { classes } = this.props
		return (
			<Grid item xs={12} className={classes.content}>
				<FormLabel className={classes.shrink}>{utils.t('eventSetting', 'EventDialog')}</FormLabel>
				<Grid item xs={12}>
					<FormControlLabel
						control={
							<Radio
								checked={this.state.activityConditions === 'orders'}
								onChange={(event) => {
									this.setState({
										activityConditions: event.target.value,
										accumulationBets: 0
									}, ()=>{
										if (this.state.activityConditions === 'orders') {
											this.handleErrorState('activityConditionsBets',  false)
										}
									})
								}}
								value="orders"
								name="radio-button"
								color="primary"
								disabled={this.props.dialogType === 'edit'}
							/>
						}
						label={utils.t('accumulatedBets', 'EventDialog')}
						className={classes.controlStyle}
					/>
					<TextField
						className={clsx(classes.textField,
							{
								[classes.vaildErrorMarginReset]: !this.state.error.activityConditionsOrders
							}
						)}
						label=""
						value={this.state.accumulationOrders}
						disabled={this.state.activityConditions !== 'orders' || this.props.dialogType === 'edit'}
						onChange={(event) => {
							const _next = utils.clearNoNum(event.target.value, false, false) || 0
							this.setState({
								accumulationOrders: _next
							})
							this.errorVaild.activityConditionsOrders.vaild(_next)
						}}
						onBlur={(event) => {
							this.errorVaild.activityConditionsOrders.vaild(event.target.value)
						}}
						error={this.state.error.activityConditionsOrders}
						helperText={this.state.error.activityConditionsOrders ? this.state.errorMsg.activityConditionsOrders: ''}
					/>
				</Grid>
				<Grid item xs={12}>
					<FormControlLabel
						control={
							<Radio
								checked={this.state.activityConditions === 'bets'}
								onChange={(event) => {
									this.setState({
										activityConditions: event.target.value,
										accumulationOrders: 0
									}, () => {
										if (this.state.activityConditions === 'bets') {
											this.handleErrorState('activityConditionsOrders',  false)
										}
									})
								}}
								value="bets"
								name="radio-button"
								color="primary"
								disabled={this.props.dialogType === 'edit'}
							/>
						}
						label={utils.t('accumulatedAmount', 'EventDialog')}
						className={classes.controlStyle}
					/>
					<TextField
						className={clsx(classes.textField,
							{
								[classes.vaildErrorMarginReset]: !this.state.error.activityConditionsBets
							}
						)}
						label=""
						value={this.state.accumulationBets}
						disabled={this.state.activityConditions !== 'bets' || this.props.dialogType === 'edit'}
						onChange={(event) => {
							const _next = utils.clearNoNum(event.target.value, false, false) || 0
							this.setState({
								accumulationBets: _next
							})
							this.errorVaild.activityConditionsBets.vaild(_next)
						}}
						onBlur={(event) => {
							this.errorVaild.activityConditionsBets.vaild(event.target.value)
						}}
						error={this.state.error.activityConditionsBets}
						helperText={this.state.error.activityConditionsBets ? this.state.errorMsg.activityConditionsBets : ''}
					/>
				</Grid>
				<Grid item xs={12} className={classes.labelGroup}>
					<span className={classes.vaildErrorMarginReset}>{utils.t('reachGiveAway', 'EventDialog')}：</span>
					<TextField
						className={clsx(classes.textField,
							{
								[classes.vaildErrorMarginReset]: !this.state.error.accumulationReach
							}
						)}
						label=""
						value={this.state.accumulationReach}
						onChange={(event) => {
							const _next = utils.clearNoNum(event.target.value, false, false) || 0
							this.setState({
								accumulationReach: _next
							})
							this.errorVaild.accumulationReach.vaild(_next)
						}}
						onBlur={(event) => {
							this.errorVaild.accumulationReach.vaild(event.target.value)
						}}
						disabled={this.props.dialogType === 'edit'}
						error={this.state.error.accumulationReach}
						helperText={this.state.error.accumulationReach ? this.state.errorMsg.accumulationReach : ''}
					/>
				</Grid>
				<FormLabel className={clsx(classes.shrink,classes.marginTop)}>{utils.t('eventLimitSetting', 'EventDialog')}</FormLabel>
				<Grid item xs={12}>
					<FormControlLabel
						control={
							<Checkbox
								checked={this.state.accountLimit}
								onChange={(event) => {
									this.setState({
										accountLimit: event.target.checked,
										accountLimitCount: 0
									})
									this.handleErrorState('accountLimitCount',  false)
								}}
								color="primary"
								disabled={this.props.dialogType === 'edit'}
							/>
						}
						label={utils.t('limitForAnAccount', 'EventDialog')}
						className={classes.controlStyle}
					/>
					<TextField
						className={clsx(classes.textField,
							{
								[classes.vaildErrorMarginReset]: !this.state.error.accountLimitCount
							}
						)}
						label=""
						value={this.state.accountLimitCount}
						disabled={!this.state.accountLimit||this.props.dialogType === 'edit'}
						onChange={(event) => {
							const _next = utils.clearNoNum(event.target.value, false, false) || 0
							this.setState({
								accountLimitCount: _next
							})
							this.errorVaild.accountLimitCount.vaild(_next)
						}}
						onBlur={(event) => {
							this.errorVaild.accountLimitCount.vaild(event.target.value)
						}}
						error={this.state.error.accountLimitCount}
						helperText={this.state.error.accountLimitCount ? this.state.errorMsg.accountLimitCount : ''}
					/>
				</Grid>
				<Grid item xs={12}>
					<FormControlLabel
						control={
							<Checkbox
								checked={this.state.allPlatformLimit}
								onChange={(event) => {
									this.setState({
										allPlatformLimit: event.target.checked,
										allPlatformLimitCount: 0
									})
									this.handleErrorState('allPlatformLimitCount',  false)
								}}
								color="primary"
								disabled={this.props.dialogType === 'edit'}
							/>
						}
						label={utils.t('limitForAllPlatform', 'EventDialog')}
						className={classes.controlStyle}
					/>
					<TextField
						className={clsx(classes.textField,
							{
								[classes.vaildErrorMarginReset]: !this.state.error.allPlatformLimitCount
							}
						)}
						label=""
						value={this.state.allPlatformLimitCount}
						disabled={!this.state.allPlatformLimit||this.props.dialogType === 'edit'}
						onChange={(event) => {
							const _next = utils.clearNoNum(event.target.value, false, false) || 0
							this.setState({
								allPlatformLimitCount: _next
							})
							this.errorVaild.allPlatformLimitCount.vaild(_next)
						}}
						onBlur={(event) => {
							this.errorVaild.allPlatformLimitCount.vaild(event.target.value)
						}}
						error={this.state.error.allPlatformLimitCount}
						helperText={this.state.error.allPlatformLimitCount ? this.state.errorMsg.allPlatformLimitCount : ''}
					/>
				</Grid>
				<Grid item xs={12} className={classes.labelGroup}>
					<span>{utils.t('limitResetPeriod', 'EventDialog')}：</span>
					<Select
						className={classes.textField}
						value={this.state.resetLimitCycle}
						onChange={(event) =>
							this.setState({
								resetLimitCycle: event.target.value
							})
						}
						disabled={this.props.dialogType === 'edit'}
					>
						{this.state.cycleList.map(item => {
							return <MenuItem value={item.value} key={item.value}>{utils.t(item.label, 'EventDialog')}</MenuItem>
						})}
					</Select>
					{this.state.resetLimitCycle === '9' && <span>{utils.t('firstDayOfEveryMonth', 'EventDialog')}&nbsp;</span>}
					{this.state.resetLimitCycle !== '0' && <span>{utils.t('resetTime', 'EventDialog')}</span>}
				</Grid>
				<FormLabel className={clsx(classes.shrink,classes.marginTop)}>{utils.t('eventBonusLimitSetting', 'EventDialog')}</FormLabel>
				<Grid item xs={12} className={classes.labelGroup}>
					<span className={classes.vaildErrorMarginReset}>{utils.t('prizePoolAmount', 'EventDialog')}：</span>
					<TextField
						className={clsx(classes.textField,
							{
								[classes.vaildErrorMarginReset]: !this.state.error.bonunsTotal
							}
						)}
						label=""
						value={this.state.bonunsTotal}
						onChange={(event) => {
							const _next = utils.clearNoNum(event.target.value, false, false) || 0
							this.setState({
								bonunsTotal: _next
							})
							this.errorVaild.bonunsTotal.vaild(_next)
						}}
						onBlur={(event) => {
							this.errorVaild.bonunsTotal.vaild(event.target.value)
						}}
						error={this.state.error.bonunsTotal}
						helperText={this.state.error.bonunsTotal ? this.state.errorMsg.bonunsTotal : ''}
						disabled={this.props.dialogType === 'edit'}
					/>
				</Grid>
				<Grid item xs={12} className={classes.labelGroup}>
					<span className={classes.vaildErrorMarginReset}>{utils.t('prizePoolLess', 'EventDialog')}：</span>
					<TextField
						className={clsx(classes.textField,
							{
								[classes.vaildErrorMarginReset]: !this.state.error.bonunsMin
							}
						)}
						label=""
						value={this.state.bonunsMin}
						onChange={(event) => {
							const _next = utils.clearNoNum(event.target.value, false, false) || 0
							this.setState({
								bonunsMin: _next
							})
							this.errorVaild.bonunsMin.vaild(_next)
						}}
						onBlur={(event) => {
							this.errorVaild.bonunsMin.vaild(event.target.value)
						}}
						error={this.state.error.bonunsMin}
						helperText={this.state.error.bonunsMin ? this.state.errorMsg.bonunsMin : ''}
						disabled={this.props.dialogType === 'edit'}
					/>
					<span>{utils.t('onlySmallPrizes', 'EventDialog')}</span>
				</Grid>
				<Grid item xs={12} className={classes.labelGroup}>
					<span>{utils.t('bonusPoolResetPeriod', 'EventDialog')}：</span>
					<Select
						className={classes.textField}
						value={this.state.resetbonunsCycle}
						onChange={(event) =>
							this.setState({
								resetbonunsCycle: event.target.value
							})
						}
						disabled={this.props.dialogType === 'edit'}
					>
						{this.state.cycleList.map(item => {
							return <MenuItem value={item.value} key={item.value}>{utils.t(item.label, 'EventDialog')}</MenuItem>
						})}
					</Select>
					{this.state.resetbonunsCycle === '9' && <span>{utils.t('firstDayOfEveryMonth', 'EventDialog')}&nbsp;</span>}
					{this.state.resetbonunsCycle !== '0' && <span>{utils.t('resetTime', 'EventDialog')}</span>}
				</Grid>
			</Grid>
		)
	}
}

const styles = () => {
  return {
	content: {
		paddingLeft: '10px',
	},
    shrink: {
		fontSize: 20,
		fontWeight: 'bold',
		color: '#000000',
		transform: 'translate(0, 1.5px) scale(0.75)',
		transformOrigin: 'top left',
	},
	textField: {
		width: '150px',
		fontSize: 13,
		margin: 3,
	},
	labelGroup: {
		display: 'flex',
		alignItems: 'center',
		fontSize: 14,
		'& span': {
			fontSize: 13
		}
	},
	marginTop: {
		marginTop: 15,
	},
	controlStyle: {
		marginBottom: 0,
		'& span': {
			fontSize: 13
		}
	},
	vaildErrorMarginReset: {
		marginBottom: 23
	},
  }
}

GiveFreeGame.propTypes = {
  onRef: PropTypes.func,
  classes: PropTypes.objectOf(PropTypes.string),
  data: PropTypes.object,
	dialogType: PropTypes.string,
  handleChangeState: PropTypes.func,
}

export default hoc(styles)(GiveFreeGame)